import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { WebloginVehiclesPage } from './vehicles';
import { WebloginVehiclePage } from './vehicle';

const Container = styled.div``;
const STATE = {
  selected: null,
};
/* eslint-disable react/prefer-stateless-function */
class WebloginPageComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  render() {
    return (
      <Container>
        <Switch>
          <Route
            path="(.*)/vehicles/:id(.*)"
            render={(component) => {
              return <WebloginVehiclePage vehicleId={component.match.params.id} />;
            }}
          />
          <Route path="(.*)/vehicles(.*)" component={WebloginVehiclesPage} />
          <Route render={() => <Redirect to="/vehicles" />} />
        </Switch>
      </Container>
    );
  }
}

WebloginPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    get() {},
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebloginPage = compose(withConnect, withRouter)(WebloginPageComp);
